/* eslint-disable max-len */
import {
  helpers,
  required as requiredV,
} from '@vuelidate/validators';

// #region STTEDRA
import {
// useDev,
// useNormalizer,
} from '@sttedra_ui/framework';
// #endregion

// const {getString} = useNormalizer();

function validateNifNie(value) {
  const validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
  const nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
  const nieRexp = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
  const str = value.toString().toUpperCase();

  if (!nifRexp.test(str) && !nieRexp.test(str)) return false;

  const nie = str
    .replace(/^[X]/, '0')
    .replace(/^[Y]/, '1')
    .replace(/^[Z]/, '2');

  const letter = str.substr(-1);
  const charIndex = parseInt(nie.substr(0, 8)) % 23;

  if (validChars.charAt(charIndex) === letter) return true;

  return false;
}

function supportNumValidation(value) {
  const str = value.toString().replace(/[\s.,]/g, '');

  if (!str) return false;

  const firstChar = str.charAt(0).toUpperCase();

  // Verificación para NIE
  if (firstChar === 'C' || firstChar === 'E') {
    const numValue = str.substr(1);

    const hasValidValue = !isNaN(numValue) && numValue.length === 8;
    // Especial case for NIE with 8 digits that are all zeros.
    if (hasValidValue && numValue !== '00000000') {
      return true;
    }
  }

  // Verificación para DNI
  if (str.length === 9 && !isNaN(str.substr(3))) {
    const letters = str.substr(0, 3).toUpperCase();
    const digits = str.substr(3);
    if (/^[A-Z]{3}$/.test(letters) && digits.length === 6) {
      return true;
    }
  }

  return false;
}

function supportNumValidationNIE(value) {
  const str = value.toString().replace(/[\s.,]/g, '');

  if (!str) return false;

  const firstChar = str.charAt(0).toUpperCase();

  if (firstChar === 'C' || firstChar === 'E') {
    const numValue = str.substr(1);

    const hasValidValue = !isNaN(numValue) && numValue.length === 8;
    // Especial case for NIE with 8 digits that are all zeros.
    if (hasValidValue && numValue !== '00000000') {
      return true;
    }
  }

  return false;
}

function supportNumValidationDNI(value) {
  const str = value.toString().replace(/[\s.,]/g, '');

  if (!str) return false;

  if (str.length === 9 && !isNaN(str.substr(3))) {
    const letters = str.substr(0, 3).toUpperCase();
    const digits = str.substr(3);
    if (/^[A-Z]{3}$/.test(letters) && digits.length === 6) {
      return true;
    }
  }

  return false;
}

function phoneExtension(value) {
  if (value) {
    if (value.charAt(0) !== '+' ||
      isNaN(value.substr(1, (value.length - 1))) || value.length < 13) {
      return true;
    }
  }
  return false;
}

function validatorInputText(value) {
  const regExp = /^(?!^[-·`´\s]*$)[a-zA-ZáéíóúÁÉÍÓÚñÑàèìòùÀÈÌÒÙçÇüÜäÄëËïÏöÖßâêîôûÂÊÎÔÛ\s-·`´']*$/;
  return regExp.test(value);
}

const result = Object.freeze({
  nifNieValidation: helpers.withMessage('El NIF o el NIE no es válido', validateNifNie),
  // eslint-disable-next-line max-len
  requireNumValidation: helpers.withMessage('Campo número de soporte en blanco. Introduzca su número de soporte', requiredV),
  supportNumValidation: helpers.withMessage('El número de soporte no es válido.', supportNumValidation),
  supportNumValidationDNI: helpers.withMessage('Código de soporte DNI inválido. El código debe consistir de 3 letras y 6 dígitos. Ejemplo: AAA123456', supportNumValidationDNI),
  supportNumValidationNIE: helpers.withMessage('Código de soporte NIE inválido. El código debe consistir en una letra (“C” o “E”) y 8 dígitos. En caso de no tener 8 dígitos, debe rellenarse con ceros (0) por la izquierda. Ejemplo: C183 debe introducirse como C00000183', supportNumValidationNIE),
  phoneExtension: helpers.withMessage('El teléfono no es válido', phoneExtension),
  validatorName: helpers.withMessage('El campo nombre contiene caracteres inválidos', validatorInputText),
  validatorSurname: helpers.withMessage('El campo apellido 2 contiene caracteres inválidos', validatorInputText),
  validatorSecondName: helpers.withMessage('El campo segundo apellido contiene caracteres inválidos', validatorInputText),
});

export default function() {
  return result;
}
